import { render, staticRenderFns } from "./workOrder.vue?vue&type=template&id=bede70fc&scoped=true&"
import script from "./workOrder.vue?vue&type=script&lang=ts&"
export * from "./workOrder.vue?vue&type=script&lang=ts&"
import style0 from "./workOrder.vue?vue&type=style&index=0&id=bede70fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bede70fc",
  null
  
)

export default component.exports